var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconRefabricCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 427319282"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M28.9321 71.8713L24.9932 67.9323L71.966 20.9595L75.9049 24.8985L28.9321 71.8713Z",
    fill: "#D1EF70"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.0548 71.8716L0.0947266 50.9115L4.03368 46.9725L24.9938 67.9326L21.0548 71.8716Z",
    fill: "#D1EF70"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRefabricCheck);
export default __webpack_public_path__ + "static/media/icon-refabric-check.74ca62dadcdcfb2f01a18f52f73ed78b.svg";
export { ForwardRef as ReactComponent };